export default {
    // ios() {
    //     let u = navigator.userAgent;
    //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //     return isiOS
    // }
    ios() {
        let u = navigator.userAgent;
        if(u.match(/Mac OS X/i) == 'Mac OS X'){
            return true
        }
    }
}